import type { ComponentPropsWithoutRef, ReactNode } from "react";
import classNames from "classnames";

export interface TableWrapperProps extends ComponentPropsWithoutRef<"div"> {
  children: ReactNode;
}

export const TableWrapper = ({ children, ...props }: TableWrapperProps) => (
  <div className={classNames("overflow-x-auto px-6 lg:px-9")} {...props}>
    {children}
  </div>
);
